import React, { useState } from 'react';
import swal from 'sweetalert';
import { MdPictureAsPdf } from 'react-icons/md';

const TableComponent = ({ columns, data, onDelete, onEdit, onCopy, onFaqs, isShowAction = true, isEditBtn = true, isDeleteBtn = true, isCopyBtn = false, isFaqsBtn = false, editBtnLabel = 'Edit', inlineEditFields = [], onInlineEdit, inlineSelectOptions = {} }) => {
    const [editingCell, setEditingCell] = useState(null);
    const [editValue, setEditValue] = useState('');

    const onDeleteClick = (item) => {
        swal({
            title: "Are you sure want to delete?",
            icon: "warning",
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            buttons: true
        }).then((willDelete) => {
            if (willDelete) {
                onDelete && onDelete(item);
            }
        });
    }

    const onEditClick = (item) => {
        onEdit && onEdit(item);
    }

    const onCopyClick = (item) => {
        onCopy && onCopy(item);
    }

    const onFaqsClick = (item) => {
        onFaqs && onFaqs(item);
    }

    const handleInlineEditStart = (item, field, value) => {
        setEditingCell(`${item.id}-${field}`);
        setEditValue(value);
    }

    const handleInlineEditChange = (e) => {
        setEditValue(e.target.value);
    }

    const handleInlineEditSave = (item, field) => {
        onInlineEdit && onInlineEdit(item, field, editValue);
        setEditingCell(null);
        setEditValue('');
    }

    const handleInlineEditCancel = () => {
        setEditingCell(null);
        setEditValue('');
    }

    return (
        <React.Fragment>
            {
                (data && data.length > 0) &&
                <table className='table table-hover'>
                    <thead className='thead'>
                        <tr>
                            {
                                columns.map((element, key) => {
                                    return (
                                        <th key={key}>{element.lable}</th>
                                    )
                                })
                            }
                            {isShowAction &&
                                <th>Action</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((element, key) => {
                                return (
                                    <tr key={key}>
                                        {
                                            columns.map((childElement, childKey) => {
                                                const value = element[childElement.field];
                                                const isEditingCell = editingCell === `${element.id}-${childElement.field}`;
                                                const isInlineEditable = inlineEditFields.includes(childElement.field);

                                                // handle image field
                                                if (childElement.field === 'image') {
                                                    return (
                                                        <td key={childKey}><img src={value} width={100} height={childElement.height ? childElement.height : 100} alt='slider_iamges' /></td>
                                                    );
                                                }

                                                // handle link field
                                                if (childElement.isLink) {
                                                    return (
                                                        <td key={childKey}>
                                                            <a href={element[childElement.link]} target="_blank" rel="noopener noreferrer"><MdPictureAsPdf size={20}></MdPictureAsPdf>&nbsp;{value}</a>
                                                        </td>
                                                    );
                                                }

                                                // handle inline editing
                                                if (isInlineEditable && isEditingCell) {
                                                    const selectOpts = inlineSelectOptions[childElement.field];
                                                    return (
                                                        <td key={childKey}>
                                                            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                                {selectOpts ? (
                                                                    <select value={editValue} onChange={handleInlineEditChange} className="form-select">
                                                                        {selectOpts.map(opt => <option key={opt.id} value={opt.id}>{opt.title}</option>)}
                                                                    </select>
                                                                ) : (
                                                                    <textarea
                                                                        type="text"
                                                                        value={editValue}
                                                                        onChange={handleInlineEditChange}
                                                                        className="form-control"
                                                                        style={{ width: '500px' }}
                                                                        autoFocus
                                                                    />
                                                                )}
                                                                <button
                                                                    className="btn btn-sm btn-success"
                                                                    onClick={() => handleInlineEditSave(element, childElement.field)}
                                                                >
                                                                    Save
                                                                </button>
                                                                <button
                                                                    className="btn btn-sm btn-secondary"
                                                                    onClick={handleInlineEditCancel}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </td>
                                                    );
                                                }

                                                if (isInlineEditable) {
                                                    const selectOpts = inlineSelectOptions[childElement.field];
                                                    const display = selectOpts ? (selectOpts.find(o => String(o.id) === String(value)) || {}).name || value : value;
                                                    return (
                                                        <td key={childKey} style={{ cursor: 'pointer' }} onClick={() => handleInlineEditStart(element, childElement.field, value)}>
                                                            {display} <span style={{ fontSize: '12px', color: '#999' }}>(click to edit)</span>
                                                        </td>
                                                    );
                                                }

                                                // handle truncation
                                                if (childElement.truncate && typeof value === 'string') {
                                                    const t = childElement.truncate;
                                                    const display = value.length > t ? value.substring(0, t) + '...' : value;
                                                    return (
                                                        <td key={childKey} title={value}>{display}</td>
                                                    );
                                                }

                                                return (
                                                    <td key={childKey}>{value}</td>
                                                );
                                            })
                                        }
                                        {isShowAction &&
                                            <td>
                                                {isEditBtn &&
                                                    <button type="button" className="btn btn-outline-primary btn-sm me-2" onClick={() => onEditClick(element)}>{editBtnLabel}</button>
                                                }
                                                {isCopyBtn &&
                                                    <button type="button" className="btn btn-outline-secondary btn-sm me-2" onClick={() => onCopyClick(element)}>Copy</button>
                                                }
                                                {isFaqsBtn &&
                                                    <button type="button" className="btn btn-outline-info btn-sm me-2" onClick={() => onFaqsClick(element)}>FAQs</button>
                                                }
                                                {isDeleteBtn &&
                                                    <button type="button" className="btn btn-outline-danger btn-sm me-2" onClick={() => onDeleteClick(element)}>Delete</button>
                                                }
                                            </td>
                                        }
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            }
        </React.Fragment>
    )
}

export default TableComponent; 